var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('session-breadcrumbs',{attrs:{"sessionId":_vm.sessionId,"backRoute":_vm.backRoute,"backLabel":"Monitor"}}),_c('hr',{staticClass:"bg-secondary"}),_c('view-session-progress',{attrs:{"sessionId":_vm.sessionId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }